import * as Diff from "diff";

export const DiffText = ({ text1, text2 }: { text1: string; text2: string }) => {
  const diff = Diff.diffChars(text1, text2);

  return (
    <div style={{ whiteSpace: "pre-wrap" }}>
      {diff.map((part, index) => {
        let className = "diff";

        if (part.added) {
          className = "diff-new";
        } else if (part.removed) {
          className = "diff-deleted";
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          <span key={index} className={className}>
            {part.value}
          </span>
        );
      })}
    </div>
  );
};
